<script setup>
  import { computed } from 'vue';

  const props = defineProps({
    proForecast: {
      type: Object,
      required: true
    }
  });

  const forecastText = computed(() => {
    return (text) => {
      return text
        .replace(/\n/g, '<br>')
        .replace(/<br><br>/g, '<br>')
        .replace(/<br><br><br>/g, '<br><br>')
        .replace(/\*/g, "<span class='bullet'>&nbsp;&bull;&nbsp;</span>");
    }
  });

</script>

<template>
  <div class="jwx-pro-forecast__body">
    <section
      v-for="day in props.proForecast.days"
      :key="day.date_formatted"    
      class="jwx-page__section"
    >
      <div class="jwx-pro-forecast__block jwx-block">
        <div class="jwx-block__body-content">
          <h3 class="jwx-pro-forecast__day">{{ day.date_formatted }}</h3>
          <div
            class="jwx-pro-forecast__text" 
            data-preformatted-text="true"
            v-html="forecastText(day.summary)"
          >
          </div>
        </div>
      </div>
    </section>
  </div>
</template>